
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError } from '@/fit-components/dialog/main';
import VHeader from '../components/sub-header.vue';
import VTable from '../components/table.vue';
import { queryTraffic, queryCases } from '../api';
import { NcovDataType } from '../types';
import { util, biHottag, language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import LoadFailed from '@/components/load-failed.vue';

export enum PageType {
  traffic = 'traffic',
  cases = 'cases',
}

@Component({
  components: { VHeader, VTable, LoadFailed },
})
export default class AreaTable extends Vue {
  @Prop({ default: 'traffic' }) public pageType!: PageType;
  bannerType = '';
  loadFailed = false;
  lang = language.getLanguage();
  trafficCols = [
    {
      title: i18n('班次'),
      key: 'tranId',
      width: '15.3%',
      color: '#0DBCD3',
    },
    {
      title: i18n('乘搭日期'),
      key: 'date',
      width: '26.9%',
      color: '#CD3632',
    },
    {
      title: i18n('起點及終點'),
      key: 'point',
      width: '26.9%',
    },
    {
      title: i18n('相關個案'),
      key: 'static',
      width: '24.3%',
    },
  ];
  casesCols = [
    {
      title: i18n('個案編號'),
      key: 'index',
      width: '10%',
    },
    {
      title: i18n('確診日'),
      key: 'date',
      color: '#0DBCD3',
      width: '26%',
    },
    {
      title: i18n('性別'),
      key: 'sex',
      width: '12.5%',
    },
    {
      title: i18n('年齡'),
      key: 'age',
      width: '12.5%',
    },
    {
      title: i18n('狀態'),
      key: 'status',
      width: '12.5%',
    },
    {
      title: i18n('香港/非香港居民'),
      key: 'type',
      width: '21.4%',
    },
  ];

  trafficData = [];

  casesData = [];

  get isTraffic() {
    return 'traffic' === this.pageType;
  }

  get isCases() {
    return 'cases' === this.pageType;
  }

  get title() {
    if (this.isTraffic) {
      return i18n('确认个案曾乘搭的交通工具查询');
    }
    if (this.isCases) {
      return i18n('本港确诊新型冠状病毒的个案详情');
    }
  }

  get cols() {
    if (this.isTraffic) {
      return this.trafficCols;
    }
    if (this.isCases) {
      return this.casesCols;
    }
  }
  get dataset() {
    if (this.isTraffic) {
      return this.trafficData;
    }
    if (this.isCases) {
      return this.casesData;
    }
  }
  async activated() {
    showLoading();
    this.loadFailed = false;
    if (this.isTraffic) {
      this.bannerType = this.pageType;
      util.changeTitle(i18n('曾乘搭交通工具'));
      biHottag('wallet.cvirus.transport.index_brow');
      const [err, data] = await util.to(queryTraffic());
      if (err) {
        hideLoading();
        this.loadFailed = true;
        return;
      }
      const { f_ncov_data } = data;
      f_ncov_data.forEach((element) => {
        if (!element.point) {
          element.point = i18n('暫不適用');
        }
      });
      this.trafficData = f_ncov_data;
    } else if (this.isCases) {
      this.bannerType = this.pageType;
      util.changeTitle(i18n('個案詳情'));
      biHottag('wallet.cvirus.cases.index_brow');
      const [err, data] = await util.to(queryCases());
      if (err) {
        hideLoading();
        this.loadFailed = true;
        return;
      }
      const { f_ncov_data } = data;
      this.casesData = f_ncov_data;
    }
    hideLoading();
  }
  deactivated() {
    this.casesData = [];
    this.trafficData = [];
    this.bannerType = '';
  }
}
